var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYellowStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 46,
    viewBox: "0 0 48 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 17.7495V18.6857C47.7647 19.3983 47.496 19.984 47.0171 20.5631C45.3449 22.5823 42.6532 24.7584 40.7307 26.6525C39.7394 27.6304 38.7548 28.62 37.7953 29.6297L39.9397 42.4494C40.0916 45.1662 38.0773 46.6698 35.5324 45.6385L23.9676 39.6141L12.5947 45.5801C9.90463 46.7415 7.84033 45.1562 8.07229 42.2775L10.2017 29.6297C9.21041 28.5883 8.19578 27.5687 7.17281 26.5591C4.97667 24.3946 2.61031 22.3487 0.57604 20.0291C-0.693916 17.9814 0.225592 16.0123 2.45511 15.3781L15.5385 13.4139L21.3893 1.59215C22.8262 -0.492178 25.1808 -0.47549 26.6077 1.59215L32.4585 13.4139L45.4684 15.3581C46.7217 15.6969 47.6579 16.4662 48 17.7495Z",
    fill: "#FFC107"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowStar);
export default __webpack_public_path__ + "static/media/yellowStar.478f733e4f42f801a11007dff8d6830e.svg";
export { ForwardRef as ReactComponent };